<script>
export default {
  name: 'InfoBubbleMixin',
  data() {
    return {
      showPopup: false,
      localStorageKey: 'washiFirstTimeData',
      firstTimeData: {
        conviction: false,
        skills: false,
        experience: false,
        formations: false,
        projects: false,
      },
    };
  },
  beforeMount() {
    const firstTimeData = JSON.parse(localStorage.getItem(this.localStorageKey));

    if (firstTimeData) {
      this.firstTimeData = firstTimeData;
    }
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    setSeen(key) {
      this.firstTimeData[key] = true;
      localStorage.setItem(this.localStorageKey, JSON.stringify(this.firstTimeData));
    },
    closePopup() {
      this.showPopup = false;
    },
    togglePopup() {
      this.showPopup = !this.showPopup;
    },
    checkIfMustOpenPopup(key) {
      if (!this.firstTimeData[key]) {
        this.openPopup();
        this.setSeen(key);
      }
    },
  },
};
</script>
